/**
 * Modal Component — Reusable modal dialog (refined)
 */
import React from 'react';
import { X } from 'lucide-react';

export function Modal({ isOpen, onClose, title, icon, children, size = 'md' }) {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'w-72',
    md: 'w-80',
    lg: 'w-96',
    xl: 'w-[32rem]'
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadeIn p-4">
      <div className={`bg-white rounded-3xl p-6 ${sizeClasses[size]} shadow-soft-lg relative animate-scaleIn max-h-[85vh] overflow-y-auto scrollbar-thin`}>
        <button
          onClick={onClose}
          className="absolute top-3.5 right-3.5 p-1.5 text-stone-400 hover:text-stone-600 hover:bg-stone-100 rounded-xl transition-all duration-200"
        >
          <X size={18} />
        </button>

        {(title || icon) && (
          <div className="text-center mb-5">
            {icon && (
              <div className="w-12 h-12 bg-gradient-to-br from-primary-50 to-warm-100 rounded-2xl flex items-center justify-center text-2xl mx-auto mb-2.5 shadow-soft">
                {icon}
              </div>
            )}
            {title && (
              <h3 className="text-lg font-bold text-stone-900">{title}</h3>
            )}
          </div>
        )}

        {children}
      </div>
    </div>
  );
}

export default Modal;
